import { Injectable, isDevMode } from '@angular/core';
import { VIRTUAL_URLS } from '@client/app/modules/business-intelligence/constants/vitrual-urls';

function getComponentMetadata (componentClass: any) {
    const metadata = {
        name: componentClass.name,
        selector: undefined,
        templateUrl: undefined,
        template: undefined,
        styleUrls: undefined,
    };

    // Try to get Angular metadata
    const annotations = componentClass.__annotations__;

    if (annotations && annotations[0]) {
        const componentMetadata = annotations[0];
        metadata.selector = componentMetadata.selector;
        metadata.templateUrl = componentMetadata.templateUrl;
        metadata.template = componentMetadata.template;
        metadata.styleUrls = componentMetadata.styleUrls;
    }


    if (componentClass.ɵcmp) {
        const [selector] = componentClass.ɵcmp.selectors;
        metadata.selector = selector[0];
    }

    return metadata;
}
const kebabToCamelCase = (s: string): string => s.replace(/-./g, x=>x[1].toUpperCase());

@Injectable({
    providedIn: 'root',
})
export class VirtualUrlService {
    constructor () {}

    get (url: any, params: any): string {
        if (typeof url !== 'string') {
            // is a component class
            const metadata = getComponentMetadata(url);
            url = kebabToCamelCase(metadata.selector || '');
        }

        const virUrl = VIRTUAL_URLS[url];
        if (!virUrl) {
            if (isDevMode()) {

                throw new Error(`Virtual url is missing: ${url}`);
            }
            return '';
        }
        const newUrl = virUrl.url;
        if (newUrl) {
            return newUrl + this.getSubUrl(url, params);
        }
        return '';
    }

    private getSubUrl (url: string, params: any): string {
        return url === 'pageDetails' ? `${params.data.page.url} (${params.data.page.title})` : '';
    }

    getRef (params: any): string {
        if (params.data && params.data.ref) {
            return params.data.ref;
        }
        if (params.ref) {
            return params.ref;
        }
        return '';
    }

    getParams (body, params): void {}

    getTitle (): void {}
}
